<ion-header class="ion-no-border shadow-b-footer" mode="ios">
  <ion-toolbar class="background-purple-ionic pb-70">
    <ion-title
      [className]="'white f14 ' + classTitle"
      [innerHTML]="title"></ion-title>
  </ion-toolbar>
</ion-header>

<section class="flex justify-content-center absolute w-100 top-60 z-index-10">
  <img alt="Image" [src]="img" />
</section>

<ion-content>
  <background-content classSubDiv="h-100 pt-64 text-center">
    <ion-label
      [className]="'f13 ' + classDesc"
      [innerHTML]="description"></ion-label>
  </background-content>
</ion-content>

<ion-footer class="ion-no-border flex align-items-center justify-content-center">
  <ps-button
    *ngIf="btnCancel"
    color="secondary"
    height="tall"
    [buttonClass]="'min-w-130' + ((btnSave || btnBlue) ? ' mr-8' : '')"
    [ngClass]="{'w-100': btnSave || btnBlue}"
    [text]="btnCancel"
    [width]="(btnSave || btnBlue) ? '100%' : 'auto'"
    (onClick)="closeModal()">
  </ps-button>

  <ps-button
    *ngIf="!!btnSave"
    height="tall"
    [buttonClass]="'min-w-130' + (btnCancel ? ' ml-8' : '')"
    [ngClass]="{'w-100': btnCancel}"
    [text]="btnSave"
    [width]="btnCancel ? 'w-100' : 'auto'"
    (onClick)="closeModal(true)">
  </ps-button>

  <ps-button
    *ngIf="!!btnBlue"
    color="light-blue"
    height="tall"
    [buttonClass]="'min-w-130' + (btnCancel ? ' ml-8' : '')"
    [ngClass]="{'w-100': btnCancel}"
    [text]="btnBlue"
    [width]="btnCancel ? '100%' : 'auto'"
    (onClick)="closeModal(true)">
  </ps-button>
</ion-footer>
